import fetchDataGate from "../services/fetchDataGate";

const handleFetchGatepasses = async ({ page, limit, params }: any) => {
  const uri = `api/gatepass/paginated?page=${page}&limit=${limit}&${params}`;
  const response = fetchDataGate({ uri });
  return response;
};

export { handleFetchGatepasses };
